import React from 'react';
import { formatPct } from './utils';

const TypologyOfferTable = ({ color, title, tipologias }) => {
    const { unidades = [], oferta_inicial_total = '0', oferta_final_total = '0' } = tipologias;

    const inicialNum = parseInt(String(oferta_inicial_total).replace(/\./g, ''), 10) || 0;
    const finalNum = parseInt(String(oferta_final_total).replace(/\./g, ''), 10) || 0;
    const dispPct = inicialNum > 0 ? (finalNum / inicialNum) * 100 : 0;

    return (
        <table className="table table-striped table-condensed" style={{ border: `3px solid ${color}` }}>
            <thead>
                <tr className="text-center" style={{ backgroundColor: color, color: '#fff' }}>
                    <td colSpan="6">{title}</td>
                </tr>
                <tr className="text-center" style={{ backgroundColor: color, color: '#fff' }}>
                    <th className="text-center" style={{ color: '#fff' }}>Tipo Imóvel</th>
                    <th className="text-center" style={{ color: '#fff' }}>Oferta Lançada</th>
                    <th className="text-center" style={{ color: '#fff' }}>(%)</th>
                    <th className="text-center" style={{ color: '#fff' }}>Oferta Final</th>
                    <th className="text-center" style={{ color: '#fff' }}>(%)</th>
                    <th className="text-center" style={{ color: '#fff' }}>Dispo.s/O.L</th>
                </tr>
            </thead>
            <tbody>
                {unidades.map((u, i) => (
                    <tr className="text-center" key={i}>
                        <td style={{ whiteSpace: 'nowrap' }}>
                            {u.quartos} {u.quartos === 1 ? 'Dormitório' : 'Dormitórios'}
                        </td>
                        <td>{u.oferta_inicial}</td>
                        <td>{formatPct(u.porcentagem_oferta_inicial)}</td>
                        <td>{u.oferta_final}</td>
                        <td>{formatPct(u.porcentagem_oferta_final)}</td>
                        <td>{formatPct(u.porcentagem_oferta_final_sob_oferta_lancada)}</td>
                    </tr>
                ))}
            </tbody>
            <tfoot>
                <tr>
                    <td>&nbsp;</td>
                    <td>{oferta_inicial_total}</td>
                    <td>100%</td>
                    <td>{oferta_final_total}</td>
                    <td>100%</td>
                    <td>{formatPct(dispPct)}</td>
                </tr>
            </tfoot>
        </table>
    );
};

export default TypologyOfferTable;
